module.exports = __webpack_public_path__ + "img/ico_pls_yes.4bde99fd.svg";